export default __webpack_public_path__ + "static/media/Marks.8b174050.svg";